import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Transition from './Transition';
import goodJobSvg from '../../images/icons/goodJob.svg';
import _ from 'lodash';
import { withStyles } from '@material-ui/core';
import LayoutContainer from '../../containers/Layout';
import moment from 'moment';
import { post } from '../../modules/utility';
import printJS from 'print-js';
import { CircularProgress } from '@material-ui/core';
import AuthUserContainer from '../../containers/AuthUser';
import Note from '../Note';

const styles = {
	goodJobIcon: {
		display: 'inline-block',
		width: 100,
		height: 100,
		backgroundImage: `url('${goodJobSvg}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
	},
	title: {
		fontSize: 50,
		display: 'inline-block',
		verticalAlign: 'middle',
		paddingLeft: 5,
		paddingTop: 5,
	},
	printButton: {
		padding: `15px 55px`,
		margin: 10,
		fontSize: 18,
		fontWeight: 800,
		lineHeight: 1.3,
	},
	logoutButton: {
		padding: `15px 55px`,
		margin: 10,
		fontSize: 18,
		fontWeight: 800,
		lineHeight: 1.3,
	},
	continueButton: {
		padding: `20px 65px`,
		margin: 10,
		fontSize: 16,
		lineHeight: 1.3,
	},
	dialogRoot: {
		//overflow: 'visible'
		//alignItems: 'end',
	},
	contentMessage: {
		lineHeight: 1.3,
		fontSize: 24,
	},
	rememberToPrintMessage: {
		padding: 10,
		lineHeight: 1.3,
		fontSize: 24,
	},
	countdown: {
		padding: 20,
		display: 'block',
		paddingTop: 20,
		marginTop: 20,
		borderTop: '1px solid #eee',
		fontSize: '120%',
	},
};

class ClockInOutSuccessfulDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			countdown: 4,
			isPrintingCe: false,
		};
	}

	handleRequestClose = () => {
		this.stopCountdown();
		this.props.onClose();
	};

	handleRequestLogout = () => {
		this.stopCountdown();
		this.props.logout();
	};

	componentDidUpdate(prevProps, prevState, snapShot) {
		// on open kick off the timer
		if (!prevProps.open && this.props.open) {
			// this.startCountdown()
		}
	}

	startCountdown = () => {
		const intervalId = setInterval(() => {
			const countdown = this.state.countdown - 1;
			this.setState({ countdown });
			if (countdown <= 0) {
				this.stopCountdown();
				this.props.logout();
			}
		}, 1000);
		this.setState({ intervalId });
	};

	stopCountdown = () => {
		if (!this.state.intervalId) {
			return;
		}
		clearInterval(this.state.intervalId);
	};

	printCeDeliveryTickets = () => {
		const { showErrors, authUser } = this.props;
		if (!authUser) {
			return showErrors([`Missing authUser`]);
		}

		this.setState({ isPrintingCe: true });
		post({
			method: 'ce.getDeliveryTicketPdf',
			params: {
				userId: authUser.userId,
			},
			callback: (err, r) => {
				this.setState({ isPrintingCe: false });
				if (err) {
					return showErrors(err);
				}

				if (!r.resource) {
					return showErrors('Missing resource');
				}
				const url = r.resource.url;
				printJS({ printable: url, type: 'pdf' });
			},
		});
	};

	render() {
		const { classes, isClockIn, isClockOut, showPrintDeliveryTickets } = this.props;

		const title = isClockIn ? 'Clock In Successful!' : 'Clock Out Successful!';

		return (
			<Dialog
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleRequestClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<DialogTitle>
					<div>
						<div className={classes.goodJobIcon} />
						<span className={classes.title}>{title}</span>
					</div>
				</DialogTitle>
				<DialogContent>
					{isClockIn && (
						<span className={classes.contentMessage}>
							Thank you for choosing to work at Superior Tank Lines and have a great day!
						</span>
					)}
					{isClockOut && this.renderClockOutContent()}

					{showPrintDeliveryTickets && (
						<Note>
							<div className={classes.rememberToPrintMessage}>
								Remember to <strong>Print</strong> your delivery tickets and then{' '}
								<strong>Logout</strong>.
							</div>
						</Note>
					)}
				</DialogContent>
				<DialogActions style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
					{showPrintDeliveryTickets && (
						<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							<Button
								variant="contained"
								color="primary"
								aria-label="Print CE Delivery Tickets"
								size="large"
								className={classes.printButton}
								disabled={this.state.isPrintingCe}
								onClick={this.printCeDeliveryTickets}
							>
								Print CE Delivery Tickets
							</Button>
						</div>
					)}

					<Button
						onClick={this.handleRequestLogout}
						color="primary"
						variant="contained"
						aria-label="Logout"
						size="large"
						className={classes.logoutButton}
					>
						Logout of Sphere
					</Button>

					<Button
						onClick={this.handleRequestClose}
						color="primary"
						variant="outlined"
						aria-label="continue"
						size="large"
						className={classes.continueButton}
					>
						Back to Dashboard
					</Button>
				</DialogActions>
				<DialogActions style={{ justifyContent: 'flex-start' }}>
					{this.state.isPrintingCe && (
						<div className={classes.runningSearch}>
							<CircularProgress size="1rem" />
							<span style={{ fontSize: '20px', padding: 10 }}>
								Generating tickets, print dialog will show up shortly
							</span>
						</div>
					)}
				</DialogActions>
				{/*
				<div className={classes.countdown}>
					<div style={{display:'flex'}}>
						<div>
							Would you like to say logged in?
						</div>
						<Button
							onClick={this.stopCountdown}
							color="primary"
							variant="outlined"
							aria-label="continue"
							size="small"
							style={{marginLeft : 10 }}
						>
							Yes
						</Button>
					</div>
					<div style={{margin:0, fontStyle:'italic', color:'#666'}}>
						Auto logging off in : <strong> {this.state.countdown} </strong> seconds
					</div>
				</div>
				*/}
			</Dialog>
		);
	}

	renderClockOutContent = () => {
		const { timeClockAnalysisResult = {} } = this.props;

		const { dateTimeOfLastClockOut } = timeClockAnalysisResult;

		if (!_.isObject(timeClockAnalysisResult)) {
			return <div>Fetching time clock analysis...</div>;
		}

		return (
			<div>Time of last clock out : {moment(dateTimeOfLastClockOut).format('M/D h:mm a')}</div>
		);
	};
}

ClockInOutSuccessfulDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	isClockIn: PropTypes.bool,
	isClockOut: PropTypes.bool,
	logout: PropTypes.func,
	timeClockAnalysisResult: PropTypes.object,
	showPrintDeliveryTickets: PropTypes.bool,
};

export default _.flow([
	LayoutContainer,
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
])(ClockInOutSuccessfulDialog);
